import { useEffect, useState } from "react";
import { InfoOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { CustomAlert, CustomTable, Text } from "../../shared/uiComponents";
import { green200, red300 } from "../../shared/Helpers/colors";
import { TableBodyAdmin } from "./tableInfo";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getAuthorizationInfoClinicalSupervisor } from "../../redux/State/clientSlice/insuranceAuthorizationSlice";
import { Loader } from "../../components/StyledComponents";

const AuthorizationsInfoClinicalSupervisor = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const [params] = useSearchParams();
  const [open, setOpen] = useState<boolean>(false);

  const loading = useSelector((state) => state.authorization.loading);
  const userId = useSelector((state) => state.account.user.id);
  const authorization = useSelector((state) => state.authorization.authorizations);

  useEffect(() => {
    if (!userId) return;
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";
    dispatch(
      getAuthorizationInfoClinicalSupervisor({
        data: {
          page,
          pageSize,
        },
        userId,
      })
    );
  }, [params, userId, dispatch]);

  return !loading ? (
    !!authorization.query?.length ? <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text size="mediumBold" title={"Authorizations Dashboard"} />
        <InfoOutlined onClick={() => setOpen(true)} />
        <CustomAlert
          open={open}
          onClose={() => setOpen(false)}
          title="Details for authorization period"
          Content={() => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Text
                title={"Expired"}
                style={{
                  backgroundColor: red300,
                  width: "max-content",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  marginBottom: "8px",
                }}
              />
              <Text
                title={"Expires in 3 month"}
                style={{
                  backgroundColor: "#FFFF5C",
                  width: "max-content",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  marginBottom: "8px",
                }}
              />
              <Text
                title={"Active"}
                style={{
                  backgroundColor: green200,
                  width: "max-content",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  marginBottom: "8px",
                }}
              />
            </div>
          )}
        />
      </div>
      <CustomTable
        headers={[
          { id: "1", name: "Client Name" },
          { id: "2", name: "Authorization Expiration Date" },
        ]}
        data={authorization}
        TableBody={TableBodyAdmin}
        loading={loading}
      />
    </div> : <></>
  ) : (
    <Loader />
  );
};

export default AuthorizationsInfoClinicalSupervisor;
